var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0H16C19.7712 0 21.6569 0 22.8284 1.17157C24 2.34315 24 4.22876 24 8V16C24 19.7712 24 21.6569 22.8284 22.8284C21.6569 24 19.7712 24 16 24H8C4.22876 24 2.34315 24 1.17157 22.8284C0 21.6569 0 19.7712 0 16V8Z",
    fill: "#4E46B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80769 16.75H7.25L7.25 14.1874L12.5481 8.87901M9.80769 16.75L16.75 16.75M9.80769 16.75L15.1058 11.4417M12.5481 8.87901L13.6442 7.78074C14.3505 7.07308 15.4956 7.07308 16.2019 7.78074C16.9082 8.48839 16.9082 9.63573 16.2019 10.3434L15.1058 11.4417M12.5481 8.87901L15.1058 11.4417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.f1e1b2af0f6608f8a8a927d02e2130f3.svg";
export { ForwardRef as ReactComponent };